var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-id"},[_c('span',{staticClass:"icon"}),_c('span',{staticClass:"custom-title"},[_vm._v(_vm._s(_vm.orderId))]),_c('span',{staticClass:"cont"},[_vm._v(_vm._s(_vm.period))])])
}
var staticRenderFns = []

export { render, staticRenderFns }